export class Step5 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step4';
    getdelaiurgence = 'form.mapa_in.getdelaiurgence';
}
